import {IDropdownContext} from '../../contexts/IDropdownContext';
import {IDropdownMenuProps} from './IDropdownMenu';

type TGetAttrsParams = (
	menuCoords: IDropdownContext['menuCoords'],
	placement: IDropdownMenuProps['placement'],
	menuRef: HTMLDivElement,
	isMobile: boolean,
	showMenu: boolean,
) => Record<string, Record<string, string>>;

export const getAttrs: TGetAttrsParams = (menuCoords, placement, menuEl, isMobile, showMenu) => {
	// Set top and left position of the menu
	// This is not heavy computation, so it's fine to do it on every render
	if (!menuCoords || isMobile || !showMenu) {
		return null;
	}

	const attrs = {};
	const newMenuCoords: Record<'top' | 'left', string> = {top: 'auto', left: 'auto'};
	const menuElWidth = parseInt(window.getComputedStyle(menuEl).width);
	const maxLeftCoordinatesScreen = document.documentElement.offsetWidth;
	let leftCoordinates = menuCoords.left;
	const isMenuOutOfVisibleScreen = leftCoordinates + menuElWidth > maxLeftCoordinatesScreen;

	if (isMenuOutOfVisibleScreen) {
		leftCoordinates = maxLeftCoordinatesScreen - menuElWidth;
	}

	// By default, the menu is positioned at the top of the trigger
	if (!placement || placement === 'top') {
		newMenuCoords.top = `${menuCoords.top}px`;
		newMenuCoords.left = `${leftCoordinates}px`;
	}

	if (placement === 'bottom' && menuEl) {
		newMenuCoords.top = `${menuCoords.top + menuCoords.triggerHeight + menuEl.offsetHeight}px`;
		newMenuCoords.left = `${leftCoordinates}px`;
	}

	attrs['style'] = newMenuCoords;

	return attrs;
};
